const KEY = 'c3-return-path';
/** The Google sign-in round trip takes seconds; a longer-lived entry is a stale one. */
const TTL_MS = 5 * 60 * 1000;

/** A path of this app that is worth coming back to: not the bare console, and never another site. */
export function isReturnable(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.includes('\\') && path !== '/';
}

/**
 * Keeps the address the person was on before Google sign-in sends them away, so a shared link
 * (`/incidents/INC-4021`) is still where they land afterwards. Sign-in itself never depends on it.
 */
export function rememberReturnPath(path: string, now = Date.now()): void {
  try {
    if (isReturnable(path)) sessionStorage.setItem(KEY, JSON.stringify({ path, at: now }));
    else sessionStorage.removeItem(KEY);
  } catch {
    // Storage can be blocked (private windows); the person just lands on the console.
  }
}

/** The remembered path, once: it is removed whether or not it is still valid. */
export function takeReturnPath(now = Date.now()): string | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const saved = JSON.parse(raw) as { path?: unknown; at?: unknown };
    if (typeof saved.path !== 'string' || typeof saved.at !== 'number') return null;
    if (now - saved.at > TTL_MS) return null;
    return isReturnable(saved.path) ? saved.path : null;
  } catch {
    return null;
  }
}
